var THREE = require('three');
// var Stats = require('stats.js');

// import { remote, shell } from "electron";
import * as dat from 'dat.gui';

// import Skybox from './objects/skybox';
// import Skysphere from './objects/skysphere';
// import Water from './objects/water/water';
// import Water2 from './objects/water2/water';
import Water3 from './objects/water3/water';
// import Water3 from './objects/water4/water';
import Bottles from './objects/bottles';
import Boat from './objects/boat';
import Header from './ui/header';
import Popup from './ui/popup';
import Register from './ui/register';
import Share from './ui/share';
import Fullscreen from '../helpers/fullscreen';
import Sounds from '../helpers/sounds';
import MyLoader from '../helpers/loader-utils';
// import {TweenMax} from 'gsap';
// import signal from 'signal-js';
import Tracking from '../helpers/tracking';


// import {OrbitControls} from './controls/OrbitControls';
var windowW, windowH, windowHalfX, windowHalfY;

// Device Orientation
// Portrait: 0, Landscape clockwise: 1, Landscape counter clockwise: 2, Portrait upside down: 3
var deviceOrientation;
var DEVICE_PORTRAIT = 0;
var DEVICE_LANDSCAPE_CLOCK = 1;
var DEVICE_LANDSCAPE_COUNTER_CLOCK = 2;
var DEVICE_PORTRAIT_REVERSED = 3;

// var canvas;
var renderer, scene, camera, controls;
var perspective = 1000;
var logo, skybox, skysphere, water, water2, water3, bottles, boat;
var header;
var score = 0, nbBottles = 0;
var bGameStarted = false;
var idTimerHasMoved = -1;
var bHasMoved = false;
var orientation = 's'; // 'n', 's', 'e', 'w'   ('s' is the default mouse position, garder en tête que le dessous de la souris sera orienté vers l'utilisateur)

var oTracking;
var oLoader;
var oSounds;
var oFullscreen = new Fullscreen();

var elDebugOrientation = document.getElementById('debug-orientation');
var elDebugCalibration = document.getElementById('debug-calibration');
var elDebugMousePosition = document.getElementById('debug-mouse-position');
var elDebugInfos = document.getElementById('debug-infos');
var elDebugOrientationChange = document.getElementById('debug-orientation-change');
var elDebugOrientationData = document.getElementById('debug-orientation-data');

var elOverlayRotate = document.querySelector('.overlay-rotate')

var bWaitingForMove, bTurnStarboardPending, bTurnPortPending;
var bWaitingForMoveDone, bTurnStarboardPendingDone, bTurnPortPendingDone;
var bShowPopupStarboard, bShowPopupPort;

var popupWait, popupTurnStarboard, popupTurnPort, popupMission, popupEnd, popupCatched, popupLevel;

var register, share;


// CHECK ORIENTATION
windowW = window.innerWidth;
windowH = document.documentElement.clientHeight; //window.innerHeight;
var bPreviousIsPortrait = windowW < windowH
console.log(`IS PORTRAIT ? `, bPreviousIsPortrait);
elOverlayRotate.style.display = bPreviousIsPortrait ? 'block' : 'none';


export function init() {
    // console.log(`Main init()`);

    oTracking = new Tracking();

    oLoader = new MyLoader(onAllFilesLoaded);
    if (window.DEBUG_SKIP_LOADER) {
      document.querySelector('.overlay-loader').style.display = 'none'
    }

    windowW = window.innerWidth;
    windowHalfX = windowW / 2;
    windowH = document.documentElement.clientHeight; //window.innerHeight;
    windowHalfY = windowH / 2;

    console.log(`window ${windowW} x ${windowH}`);

    if (window.DEBUG_DEVICE_ORIENTATION || window.DEBUG_VISIBLE) {
      document.querySelector('.debug-container').style.display = 'flex'
    } else {
      document.querySelector('.debug-container').style.display = 'none'
      console.warn(`Remove orientation device debug for performance`)
    }

    document.getElementById('app').style.display = 'block';

    scene = new THREE.Scene();
    // scene.background = new THREE.Color( 0x000000 );
    // scene.position.y = 0;
    // scene.fog = new THREE.Fog( 0xffffff, 250, 750 );

    // For three.js inspector
    // window.scene = scene;
    // window.THREE = THREE;

    const fov = 180 * ( 2 * Math.atan( innerHeight / 2 / perspective ) ) / Math.PI
    camera = new THREE.PerspectiveCamera( fov /* 130 */, window.innerWidth / window.innerHeight, 0.1, 10000 );
    camera.position.set( 0, 0, perspective);
    camera.lookAt( 0, 0, 0 );
    // camera.rotation.x = -1;
    camera.updateMatrixWorld();
    camera.updateProjectionMatrix();

    // var helper = new THREE.CameraHelper( camera );
    // scene.add( helper );

    elDebugInfos.innerHTML = `${window.innerWidth}x${window.innerHeight}`

    try {
      renderer = new THREE.WebGLRenderer( { antialias: false, alpha: true } );
      renderer.setPixelRatio( window.devicePixelRatio );
      renderer.setSize( window.innerWidth, window.innerHeight );
      renderer.gammaInput = true;
      renderer.gammaOutput = true;
      document.body.appendChild( renderer.domElement );
    } catch(e) {
      console.log(`Error initializing Threejs (Brave) - `, e)
      // See this error https://github.com/mrdoob/three.js/issues/16904#issuecomment-556386278
    }

    // Skybox
    // skybox = new Skybox();
    // skybox.create( scene, camera );

    // Skysphere
    // skysphere = new Skysphere();
    // skysphere.create( scene, camera );

    // Water
    // water = new Water();
    // water.create( scene, camera, renderer );

    // Water2
    // water2 = new Water2();
    // water2.create( scene, camera, renderer );

    // Water3
    water3 = new Water3();
    water3.create( scene, camera, renderer );

    // Bottles
    bottles = new Bottles();
    bottles.signal.add((type, bottleId)=>{
        showPopupCatched(bottleId);
    });

    // Boat
    boat = new Boat();
    boat.signal.add((type, _z) => {
      bottles.updateBoatZ(_z);
    })
    boat.create(scene, camera);

    // Header
    header = new Header();
    header.init();
    header.signal.add((type)=>{
        switch(type) {
            case 'step0' : // Not moving
                // water2.updateSpeed(type);
                water3.updateSpeed(type);
                bottles.updateSpeed(type);
            break;
            case 'step1' : // Start slow
                // water2.updateSpeed(type);
                oSounds.playRide();
                oSounds.playLevelUp();
                water3.updateSpeed(type);
                bottles.updateSpeed(type);
                oTracking.step(1);
            break;
            case 'step2' :
                // water2.updateSpeed(type);
                oSounds.playLevelUp();
                water3.updateSpeed(type);
                bottles.updateSpeed(type);
                // popupLevel.showLevelType(1);
                popupLevel.open();
                oTracking.step(2);
            break;
            case 'step3' :
                // water2.updateSpeed(type);
                oSounds.playLevelUp();
                water3.updateSpeed(type);
                bottles.updateSpeed(type);
                // popupLevel.showLevelType(2);
                popupLevel.open();
                oTracking.step(3);
            break;
            case 'end_game' :
                // popupLevel.showLevelType(3);
                // popupLevel.signal.add((type)=>{
                //     if(type == 'end_close') { end(); }
                // });
                // popupLevel.open();
                oTracking.endGame();
                document.body.classList.add('cursor-pointer')
                document.body.classList.remove('cursor-none')
                oSounds.stopAll();
                end();
            break;
            case 'fullscreen' :
              oFullscreen.switch();
              setTimeout(() => {
                resize();
              }, 200);
            break;
            default:
        }
    });

    // STATS
    // var stats = new Stats();
    // document.body.appendChild( stats.domElement );

    function animate() {
      requestAnimationFrame( animate );
      // water.render();
      // water2.render();
      water3.render();
      boat.render();
      // bottles.move();

      renderer.render( scene, camera );
      // stats.update();
    }
    animate();
    // initGUI();

    // POINTER LOCK - POINTER LOCK API
    // https://github.com/mdn/dom-examples/blob/master/pointer-lock/app.js

    // CALL EXTERNAL COMMANDE SHELL
    // https://discuss.atom.io/t/run-external-applications-from-electron/39992

    /*canvas = document.querySelector('canvas');
    canvas.requestPointerLock = canvas.requestPointerLock || canvas.mozRequestPointerLock;
    document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock;

    document.addEventListener('click', ()=>{
        console.log('lock pointer');
        canvas.requestPointerLock();
    });

    document.addEventListener('pointerlockchange', lockChangeAlert, false);
    document.addEventListener('mozpointerlockchange', lockChangeAlert, false);

    function lockChangeAlert() {
        if (document.pointerLockElement === canvas ||
            document.mozPointerLockElement === canvas) {
            console.log('The pointer lock status is now locked');
            document.addEventListener("mousemove", onDocumentMouseMove, false);
        } else {
            console.log('The pointer lock status is now unlocked');
            document.removeEventListener("mousemove", onDocumentMouseMove, false);
        }
    }*/
    // canvas.onclick = function() {
    // };

    if (window._sf1 || window._sf2) {
      register = new Register();
      register.initForm(window._sf2, onFormRegisterComplete);
      if (window.DEBUG_SHOW_FORM_ON_START) register.showForm(score);
    }

    if (window._share) {
      share = new Share();
      share.initShare();
      initPopupShare();
    }

    initIFrameMessages();
    initPopups();
    // initSounds();
    checkCompassCalibration();

    window.addEventListener('orientationchange', checkDeviceOrientation);
    checkDeviceOrientation();

    window.addEventListener('resize', resize);

    // window.addEventListener('blur', () => {
    //   console.log(`Window HAS LOST FOCUS`);
    // });
    // window.addEventListener('focus', () => {
    //   console.log(`Window HAS FOCUS`);
    // });

    var derniere_position_de_scroll_connue = 0;
    var ticking = false;
    window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
                              window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
    window.addEventListener('scroll', () => {
      derniere_position_de_scroll_connue = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(function() {
          resize();
          ticking = false;
        });
      }
      ticking = true;
    });
    resize();

    if (window.DEBUG_WATER_TEST) {
      start();
      onPopupMissionSignal('end_close');
    } else {
      wait();
    }
}

function onAllFilesLoaded() {
  console.log(`🕐 MyLoader - onAllFilesLoaded !`);
  document.querySelector('.overlay-loader').style.display = 'none'
  console.log(`MAIN - SEND MSG TO IFRAME`, popupWait.elPopup)
  popupWait.elPopup.querySelector('iframe').contentWindow.postMessage({'func': 'play'}, '*');
}

function resize() {
  windowW = window.innerWidth;
  windowHalfX = windowW / 2;
  windowH = document.documentElement.clientHeight; //window.innerHeight;
  windowHalfY = windowH / 2;
  // console.log(`/////// resize : ${windowW} x ${windowH}`, bPreviousIsPortrait);

  if (windowW > windowH && bPreviousIsPortrait) {
    console.log(`RELOAD PAGE`);
    window.location.reload();
    window.location.href = window.location.href;
  } else if (windowW < windowH) {
    bPreviousIsPortrait = true
    elOverlayRotate.style.display = 'block';
  }

  camera.aspect = windowW / windowH;
  camera.updateProjectionMatrix();
  renderer.setSize(windowW, windowH);

  header.resize();
  popupWait.resize();
  popupTurnStarboard.resize();
  popupTurnPort.resize();
  popupMission.resize();
  popupEnd.resize();
  popupCatched.resize();
  popupLevel.resize();
  water3.resize();
  boat.resize();
}

function initIFrameMessages() {
  console.log(`init iFrame messages listener`);
  if (window.addEventListener) {
    window.addEventListener("message", onMessage, false);
  } else if (window.attachEvent) {
    window.attachEvent("onmessage", onMessage, false);
  }
}
function onMessage(e) {
  console.log(`From iFrame`, e);
  // if (e.isTrusted) {
    if (e.data.func) {
      if (e.data.func === 'openRegister' && register) {
        register.showForm(score);
      } else if (e.data.func === 'loadIntroComplete') {
        oLoader.loaded('intro')
        setTimeout(() => {
          initSounds()
        }, 500);
      } else if (e.data.func === 'loadOutroComplete') {
        popupEnd.elPopup.querySelector('iframe').contentWindow.postMessage({
          'func': 'set_url',
          'discover_url' : window.DISCOVER_URL,
          'subscribe_url' : window.SUBSCRIBE_URL,
          'share': window._share
        }, '*');
      } else if (e.data.func === 'trackDiscover') {
        oTracking.clickDiscover();
      } else if (e.data.func === 'trackSubscribe') {
        oTracking.clickSubscribe();
      }
    }
  // }
}

function onFormRegisterComplete() {
  console.log(`onFormRegisterComplete`);
  popupEnd.elPopup.querySelector('iframe').contentWindow.postMessage({
    'func': 'form_complete',
    'discover_url' : window.DISCOVER_URL
  }, '*');
}

/**
 * POPUP SCRIPT
 */
function initPopupShare() {
  // console.log('CURRENT LOCATION', window.location)
  const popup_params = `scrollbars=no,resizable=yes,status=no,location=no,toolbar=no,menubar=no,width=600,height=500,left=100,top=100`;
  window.openShare = function(share_type) {
    const _score_url = `${window.location.href}&score=${score}`;
    let _url;
    // console.log(`openShare`, share_type);

    // let URLENCODED_URL = 'https://www.jeanpaulgaultier.com/en-gb/spectacles/be-the-captain';
    if (share_type === 'facebook') {
      let text = share.getShare('facebook', score);
      _url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(_score_url)}&description=${encodeURIComponent(text)}`
    } else if (share_type === 'twitter') {
      let text = share.getShare('twitter', score);
      _url = `http://twitter.com/share?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(text)}`
    }

    console.log(`SHARE URL`, _url);

    if (_url) {
      window.open(_url, 'share', popup_params);
      oTracking.clickShare(share_type, `${window.location.origin}${window.location.pathname}`);
    }
  }
}

function initPopups() {
  oLoader.add('intro')

  popupWait = new Popup('popup-wait');
  popupWait.signal.add(onPopupWaitSignal);

  popupTurnStarboard = new Popup('popup-turn-starboard');
  popupTurnPort = new Popup('popup-turn-port');

  popupMission = new Popup('popup-mission');

  popupEnd = new Popup('popup-end', () => {
    console.log(`IFRAME END is loaded`);
    // setTimeout(() => {
    //   popupEnd.elPopup.querySelector('iframe').contentWindow.postMessage({
    //     'func': 'set_url',
    //     'discover_url' : window.DISCOVER_URL,
    //     'subscribe_url' : window.SUBSCRIBE_URL,
    //     'share': window._share
    //   }, '*')
    // }, 600);
  });

  popupCatched = new Popup('popup-catched');
  popupCatched.signal.add((type)=>{
      if(type == 'end_open') {
          popupCatched.close(0.3);
      }
  });
  popupLevel = new Popup('popup-level');
  popupLevel.signal.add((type)=>{
      if(type == 'end_open') {
          popupLevel.close(0.5);
      }
  });
}

function showPopupCatched(bottleId) {
    if(bGameStarted) {
        score += bottleId == 1 ? 3 : 1;
        nbBottles++;
        header.updateScore(score);
        // popupCatched.showBottleType(Math.round(Math.random() * 2) + 1);
        popupCatched.showBottleType(bottleId);
        popupCatched.open();
        if (bottleId === 1)
          oSounds.playThreePoints();
        else
          oSounds.playOnePoints();
    }
}

function showPopupEnd() {
    // popupEnd.elPopup.querySelector('.score-end').innerHTML = nbBottles;
    popupEnd.open();
    header.showEnd(score);
    document.body.classList.remove('cursor-pointer')

    if(!window.isWEBOneParty) {
      setTimeout(()=>{
        popupEnd.signal.add(onEndClosePopupEnd);
        popupEnd.close();
      }, 7000);
    }
}

function onEndClosePopupEnd(type) {
    if(type == 'end_close') {
        popupEnd.signal.remove(onEndClosePopupEnd);
        wait();
    }
}

/**
 * ORIENTATION DEVICE
 * @param {*} e
 */
function onDeviceOrientationMoz(evt) {
  // console.log('onDeviceOrientationMoz', e);
  var tiltLR = evt.x * 90; // x is the left-to-right tilt from -1 to +1, so we need to convert to degrees
  // y is the front-to-back tilt from -1 to +1, so we need to convert to degrees
  // We also need to invert the value so tilting the device towards us (forward)
  // results in a positive value.
  var tiltFB = evt.y * -90;
  var dir = null; // MozOrientation does not provide this data
  var motUD = evt.z; // z is the vertical acceleration of the device
  onDeviceOrientationNormalized(tiltLR, tiltFB, dir, motUD)
}

function onDeviceOrientation(evt) {
  // console.log('onDeviceOrientation', e);
  var tiltLR = evt.gamma  // gamma is the left-to-right tilt in degrees, where right is positive
  var tiltFB = evt.beta // beta is the front-to-back tilt in degrees, where front is positive
  var dir = evt.alpha // alpha is the compass direction the device is facing in degrees
  var motUD = null // deviceorientation does not provide this data
  onDeviceOrientationNormalized(tiltLR, tiltFB, dir, motUD)
}

function onDeviceOrientationNormalized(tiltLR, tiltFB, dir, motUD) {

  if (deviceOrientation === DEVICE_PORTRAIT) {
    mousePosition = Math.round(tiltLR * 100 / 30) / 100
  } else if (deviceOrientation === DEVICE_LANDSCAPE_COUNTER_CLOCK) {
    mousePosition = Math.round(tiltFB * 100 / 30) / 100
  } else if (deviceOrientation === DEVICE_LANDSCAPE_CLOCK) {
    mousePosition = Math.round(-tiltFB * 100 / 30) / 100
  } else {
    mousePosition = Math.round(-tiltLR * 100 / 30) / 100
  }
  // if (window.DEBUG_DEVICE_ORIENTATION) {
  //   elDebugOrientationData.innerHTML = `tiltLR: ${Math.round(tiltLR * 100) / 100} <br/>
  //                                   tiltFB: ${Math.round(tiltFB * 100) / 100} <br/>
  //                                   dir: ${Math.round(dir * 100) / 100} <br/>`
  // }
  // if (mousePosition < 0) mousePosition = -1
  // else if (mousePosition > 0) mousePosition = 1
  mouseMovement = mousePosition
  updatePosition(mousePosition)
  checkForMoves()
}

function checkCompassCalibration() {
  elDebugCalibration.innerHTML = 'NO NEED CALIBRATION'
  window.addEventListener("compassneedscalibration", function(event) {
    console.log('NEED CALIBRATION', event);
    elDebugCalibration.innerHTML = 'NEED CALIBRATION'
  }, true);
}

function checkDeviceOrientation() {
  // console.log(`checkDeviceOrientation`, window.orientation || 'N/A desktop');
  switch (window.orientation) {
    case 0:
      deviceOrientation = DEVICE_PORTRAIT
      elDebugOrientationChange.innerHTML = 'portrait'
      break;
    case 180:
      deviceOrientation = DEVICE_PORTRAIT_REVERSED
      elDebugOrientationChange.innerHTML = 'portrait upside down'
      break;
    case -90:
      deviceOrientation = DEVICE_LANDSCAPE_CLOCK
      elDebugOrientationChange.innerHTML = 'landscape clockwise'
      break;
    case 90:
      deviceOrientation = DEVICE_LANDSCAPE_COUNTER_CLOCK
      elDebugOrientationChange.innerHTML = 'landscape counter clockwise'
      break;
  }
}

/**
 * MOUSE MOVE PLAY
 * @param {*} e
 */
function onDocumentMouseMovePlay(e) {
    // console.log('play', e);
    if(orientation == 's') {
        mousePosition = (e.clientX - windowHalfX) / windowHalfX;
        mouseMovement = e.movementX;
    }
    else if(orientation == 'n') {
        mousePosition = -(e.clientX - windowHalfX) / windowHalfX;
        mouseMovement = e.movementX * (-1);
    }
    else if(orientation == 'w') {
        mousePosition = (e.clientY - windowHalfY) / windowHalfY;
        mouseMovement = e.movementY;
    }
    else if(orientation == 'e') {
        mousePosition = -(e.clientY - windowHalfY) / windowHalfY;
        mouseMovement = e.movementY * (-1);
    }

    bHasMoved = true;
    updatePosition(mousePosition)
}

/**
 * UPDATE POSITION
 * @param {-1 to 1} mousePosition
 */
function updatePosition(mousePosition) {
  // console.log(`mouseposition`, mousePosition);
  // if (window.DEBUG_DEVICE_ORIENTATION)
  //   elDebugMousePosition.innerHTML = `position: ${mousePosition}`

  // water2.setWheelOrientation(mousePosition);
  water3.setWheelOrientation(mousePosition);
  bottles.setWheelOrientation(mousePosition);
  boat.setWheelOrientation(mousePosition);
}

/**
 * MOUSE MOVE WAIT
 * @param {*} e
 */
var mousePosition = 0; // from -1 to 1
var mouseMovement = 0; // from -1 to 1
function onDocumentMouseMoveWait(e) {
  // console.log(`onDocumentMouseMoveWait`);
    if(orientation == 's') {
        mousePosition = (e.clientX - windowHalfX) / windowHalfX;
        mouseMovement = e.movementX;
    }
    else if(orientation == 'n') {
        mousePosition = -(e.clientX - windowHalfX) / windowHalfX;
        mouseMovement = e.movementX * (-1);
    }
    else if(orientation == 'w') {
        mousePosition = (e.clientY - windowHalfY) / windowHalfY;
        mouseMovement = e.movementY;
    }
    else if(orientation == 'e') {
        mousePosition = -(e.clientY - windowHalfY) / windowHalfY;
        mouseMovement = e.movementY * (-1);
    }

    bHasMoved = true;

    updatePosition(mousePosition);
    checkForMoves()
}

function checkForMoves() {
  if(bWaitingForMove) {
    bWaitingForMove = false;
    if (mouseMovement > 0) {
        bShowPopupStarboard = true;
    } else {
        bShowPopupPort = true;
    }

    if (!window.DEBUG_WATER_TEST) {
      popupWait.close()
    }
    startTimerActivity();
  }

  if(bWaitingForMoveDone) {
    // STARBOARD (RIGHT)
    if(bTurnStarboardPendingDone == false && bTurnStarboardPending && mouseMovement > 0 && mousePosition > 0.10) {
      bShowPopupPort = true;
      bTurnStarboardPendingDone = true;
      popupTurnStarboard.close();
    }
    // PORT (LEFT)
    else if(bTurnPortPendingDone == false && bTurnPortPending && mouseMovement < 0 && mousePosition < -0.10) {
      bShowPopupStarboard = true;
      bTurnPortPendingDone = true;
      popupTurnPort.close();
    }
  }
}

function onPopupWaitSignal(type) {
  console.log(`onPopupWaitSignal`, type)
  if (type === 'end_close') {
    bWaitingForMoveDone = true;
    if (bShowPopupStarboard) {
      popupTurnStarboard.open();
    } else if (bShowPopupPort) {
      popupTurnPort.open();
    }
  } else if (type == 'end_open') {
    if (!window.DEBUG_SHOW_OUTRO_ON_START) {
      popupWait.elPopup.querySelector('.zone-cursor').addEventListener('click', onClickStart.bind(this));
      // popupWait.elPopup.addEventListener('click', onClickStart.bind(this));
      document.body.classList.add('cursor-pointer')
    }
    // document.addEventListener('mousemove', onDocumentMouseMoveWait, false);
  }
}

function addDeviceOrientationPlay() {
  // ORIENTATION DETECTION
  if (window.DeviceOrientationEvent) {
    elDebugOrientation.innerHTML = `Device Orientation Event`;
    elDebugOrientation.innerHTML += `<br/> has requestPermission : ${DeviceOrientationEvent.requestPermission}`;
    if (typeof DeviceOrientationEvent.requestPermission === 'function') {
      DeviceOrientationEvent.requestPermission()
        .then(permissionState => {
          elDebugOrientation.innerHTML += `<br />Request orientation permission : ${permissionState}`;
          // console.log(`Device Orientation Event request permission`, permissionState);
          if (permissionState === 'granted') {
            window.addEventListener('deviceorientation', onDeviceOrientation.bind(this), false);
          }
        })
        .catch(e => {
          console.error(e);
          elDebugOrientation.innerHTML += `<br/> ERROR ${console.error}`;
        });
    } else {
      elDebugOrientation.innerHTML += `<br />Device Orientation old way`;
      window.addEventListener('deviceorientation', onDeviceOrientation.bind(this), false);
    }
  } else if (window.OrientationEvent) {
    // Listen for the MozOrientation event and handle OrientationData object
    // console.log(`Device Orientation Mozilla`);
    window.addEventListener('MozOrientation', onDeviceOrientationMoz.bind(this), false);
  } else {
    // console.log(`Device Orientation NOT WORKING`);
    elDebugOrientation.innerHTML = `NO DEVICE ORIENTATION !`
  }
}

function onClickStart() {
  elDebugInfos.innerHTML += `<br />CLICK START`;

  oTracking.startGame();

  document.body.classList.remove('cursor-pointer')
  document.body.classList.add('cursor-none')
  // popupWait.elPopup.removeEventListener('click', onClickStart);
  popupWait.elPopup.querySelector('.zone-cursor').removeEventListener('click', onClickStart);

  oSounds.playWait();
  water3.resize();
  water3.playVideo();
  popupWait.close();
  bHasMoved = true

  // oFullscreen.open();

  setTimeout(() => {
    resize();
    addDeviceOrientationPlay();
    checkForMoves();
  }, 200);
  document.addEventListener('mousemove', onDocumentMouseMoveWait, false);
  // oFullscreen.getElement().addEventListener('fullscreenchange', onFullscreenChange)
  // oFullscreen.getElement().addEventListener('webkitbeginfullscreen', onFullscreenChange)
  // oFullscreen.getElement().addEventListener('webkitendfullscreen', onFullscreenChange)

  if (window.DEBUG_SKIP_TO_GAME) {
    onPopupMissionSignal('end_close');
  }
}

/* function onFullscreenChange(e) {
  console.log(`//// FULLSCREEN CHANGED`, e);
} */

function onPopupPortSignal(type) {
  if (type == 'end_close') {
    if (bShowPopupStarboard && bTurnStarboardPendingDone == false) {
      popupTurnStarboard.open();
    } else {
      popupMission.open();
    }
  } else if (type == 'end_open') {
    bTurnPortPending = true;
  }
}

function onPopupStarboardSignal(type) {
  if (type == 'end_close') {
    if (bShowPopupPort && bTurnPortPendingDone == false) {
      popupTurnPort.open();
    } else {
      popupMission.open();
    }
  } else if (type == 'end_open') {
    bTurnStarboardPending = true;
  }
}

function onPopupMissionSignal(type) {
  if (type == 'end_open') {
    if (window.DEBUG_WATER_TEST) {
      popupMission.close(0.5);
    } else {
      popupMission.close(2.5);
    }
  } else if (type == 'end_close') {
    bWaitingForMoveDone = false;
    start();
  }
}

function centerMouse(arg) {
    // Center mouse
    // console.log('PATH', app.getAppPath());
    // shell.openItem(remote.app.getAppPath() + '\\center-mouse.bat'); // pb : This opens a shell window
    // console.log('child', child);
    return new Promise((resolve)=>{
        setTimeout(resolve.bind(null, arg), 200);
        // child.stdout.on('data', (data) => {
        //     console.log(`stdout: ${data}`);
        // });
        // child.stderr.on('data', (data) => {
        //     console.log(`stderr: ${data}`);
        // });
        // child.on('close', (code) => {
        //     console.log(`child process exited with code ${code}`);
        //     resolve.bind(null, arg);
        // });
    });
}

/**
 * SOUNDS
 */
function initSounds() {
  oSounds = new Sounds();
  oSounds.init();
  header.signal.add((type) => {
    if (type === 'switchsound') {
      oSounds.switchSound();
      header.setSoundIsActive(oSounds.getSoundIsActive())
    }
  })
}

/**
 * START a ride
 */
function start() {
  startTimerActivity();
  header.show();
  // setTimeout(()=>{
    bottles.create(scene, camera, ()=>{
      header.start(onHeaderUpdateCallback);

      bottles.show().then(()=>{
        document.removeEventListener( 'mousemove', onDocumentMouseMoveWait);
        document.addEventListener( 'mousemove', onDocumentMouseMovePlay, false );
      });
    });
    bGameStarted = true;
  // }, 3000);
}

// Use callback to move bottles, because TweenMax has a different framerate than requestAnimationFrame
function onHeaderUpdateCallback() {
  // console.log(`onHeaderUpdateCallback`);
  bottles.move();
}

function startTimerActivity() {
    // console.log('startTimerActivity');
    if (window.DEBUG_DEACTIVATE_NO_ACTIVITY || window.DEBUG_WATER_TEST) {
      return;
    }
    stopTimerActivity();
    if (idTimerHasMoved < 0) {
      idTimerHasMoved = setInterval(() => {
        // console.log('timer interval, bHasMoved='+bHasMoved);
        if (!bHasMoved) {
          stopTimerActivity();
          endNoActivity();
        } else {
          bHasMoved = false;
        }
      }, 7000);
      // console.log('Start timer '+idTimerHasMoved);
    }
}

function stopTimerActivity() {
  clearInterval(idTimerHasMoved);
  idTimerHasMoved = -1;
  bHasMoved = false;
  // console.log('Clear timer '+idTimerHasMoved);
}

/**
 * WAIT for user
 */
function wait() {
    console.log('Main::wait()');
    bWaitingForMove = true;
    bTurnStarboardPending = bTurnPortPending = false;
    bWaitingForMoveDone = bTurnStarboardPendingDone = bTurnPortPendingDone = false;
    bShowPopupStarboard, bShowPopupPort = false;

    score = 0;
    nbBottles = 0;
    header.updateScore(0);
    header.reset();

    // water2.updateSpeed('step0');
    water3.updateSpeed('step0');

    centerMouse().then(()=>{
        popupTurnPort.signal.remove(wait);
        popupTurnStarboard.signal.remove(wait);
        popupMission.signal.remove(wait);

        popupTurnPort.signal.add(onPopupPortSignal);
        popupTurnStarboard.signal.add(onPopupStarboardSignal);
        popupMission.signal.add(onPopupMissionSignal);

        if (!window.DEBUG_WATER_TEST) {
          popupWait.open()
        }
    });
}

/**
 * END of game
 */
function end() {
    console.log('Main::end()');
    bGameStarted = false;
    stopTimerActivity();
    showPopupEnd();
    bottles.removeAll();
    // header.hide();
    if (window.isWebOneParty) {
      document.body.classList.remove('cursor-pointer')
      document.body.classList.remove('cursor-none')
    }
    centerMouse().then(()=>{
        document.removeEventListener( 'mousemove', onDocumentMouseMovePlay);
    });
}

function endNoActivity() {
    console.log('Main::endNoActivity()');
    bGameStarted = false;
    bottles.removeAll();
    header.hide();
    centerMouse().then(()=>{
        document.removeEventListener( 'mousemove', onDocumentMouseMovePlay);
        if(bWaitingForMoveDone) {
            popupTurnPort.signal.remove(onPopupPortSignal);
            popupTurnStarboard.signal.remove(onPopupStarboardSignal);
            popupMission.signal.remove(onPopupMissionSignal);

            if(bTurnPortPendingDone == false && bTurnPortPending) {
                popupTurnPort.signal.add(wait);
                popupTurnPort.close();
            } else if(bTurnStarboardPendingDone == false && bTurnStarboardPending) {
                popupTurnStarboard.signal.add(wait);
                popupTurnStarboard.close();
            } else {
                popupMission.signal.add(wait);
                popupMission.close();
            }
        } else {
            wait();
        }
    });
}


function initGUI() {
  // dat gui
  if (!window.datGUI) {
    var gui = new dat.GUI();
    window.datGUI = gui
  } else {
    var gui = window.datGUI
  }
  gui.addFolder("  ");

  // var paramsHTML = {color: "#000000"};
  // var htmlGUI = gui.addFolder("HTML");
  // htmlGUI.addColor(paramsHTML, 'color').onChange(() => {
  //     scene.background = new THREE.Color( paramsHTML.color );
  // });

  var cameraGui = gui.addFolder("CAMERA");
  cameraGui.add(camera.position, 'x');
  cameraGui.add(camera.position, 'y');
  cameraGui.add(camera.position, 'z');
  cameraGui.add(camera, "fov");
  cameraGui.open();
}
